export default __webpack_public_path__ + "static/media/alphabet.0d28e0c1.png";